import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import { EqualHeightElement } from "react-equal-height/clean";

const styles = {
  topperStyles: {
    p: "4px 16px 4px 20px",
    borderRadius: "0 20px 0 20px",
    mb: "2px",
    width: "fit-content",
    position: "absolute",
    top: "0",
    right: "0"
  },
  topSectionStyles: {
    p: "24px 0 0 16px",
    m: "0 0 16px 0",
    display: "flex",
    flexDirection: "column",
    position: "relative"
  }
};

export interface CardTopSectionProps {
  index: number;
  title: any;
  subHeading: any;
  topper: any;
}

const CardTopSection = (props: CardTopSectionProps) => {
  const { title, subHeading, topper } = props;
  try {
    return (
      <DtvBox sx={{ ...styles.topSectionStyles }}>
        {/* Title */}
       {title?.content && <DtvText {...title} component="h2" />}
        {/* Subheading */}
        <EqualHeightElement name={"card-sub-heading-section"}>
          {subHeading?.content && <DtvText {...subHeading} />}
        </EqualHeightElement>
        {/* Topper */}
        {topper?.content && (
          <DtvText
            {...topper}
            sx={{
              ...styles.topperStyles,
              background: topper?.background,
              fontSize: "14px !important"
            }}
          />
        )}
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="CardTopSection" error={error} />;
  }
};

export default React.memo(CardTopSection);
